var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 73,
    viewBox: "0 0 62 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1466 0C40.1326 0.271057 35.441 2.77949 32.707 6.04596C30.213 9.00921 28.1613 13.4104 28.9613 17.6876C33.347 17.8209 37.8786 15.2527 40.5044 11.9311C42.9607 8.83923 44.8195 4.46556 44.1466 0Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8996 25.0146C56.1841 20.3813 50.9625 17.6924 46.0312 17.6924C39.5211 17.6924 36.7674 20.7918 32.2444 20.7918C27.5808 20.7918 24.0377 17.7014 18.4078 17.7014C12.8777 17.7014 6.9892 21.0625 3.25558 26.8102C-1.99327 34.9039 -1.09502 50.1213 7.4111 63.083C10.4552 67.7208 14.52 72.9361 19.8368 72.9813C24.5685 73.0264 25.9023 69.963 32.3125 69.9315C38.7227 69.8954 39.9385 73.0219 44.6611 72.9722C49.9825 72.9316 54.2696 67.1524 57.3137 62.5145C59.4958 59.1895 60.3078 57.5157 62 53.7621C49.6922 49.1017 47.7188 31.6962 59.8996 25.0146Z",
    fill: "#00ADEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.bf566f8c969b4e69c02cd1fd6eabf484.svg";
export { ForwardRef as ReactComponent };